import React from "react";
import { CornerBrackets, IdCardIllustration, CAPTURE_BG } from "./capture-v2";

/**
 * Intro-screen preview of the v2 capture: the dark camera stage with the
 * corner brackets and a schematic ID inside them. Imagery only — the
 * instructions sit beside it. Drawn from the capture screen's own
 * palette and bracket component, so the intro looks like the screen
 * that follows.
 *
 * Used by the landscape (side by side) intro layout; purely
 * presentational.
 */
export default function SetupStage({ accent, style }) {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        aspectRatio: "4 / 3",
        boxSizing: "border-box",
        borderRadius: 24,
        background: CAPTURE_BG,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "11% 10%",
        overflow: "hidden",
        ...style,
      }}
    >
      {/* Guide frame at the capture's card aspect, sized to the stage
          width via a padding-box so the brackets always wrap the card. */}
      <div style={{ position: "relative", width: "100%", maxWidth: 340, aspectRatio: "180 / 114", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ position: "absolute", inset: "-12% -7%" }}>
          <CornerBrackets color={accent} size={44} radius={12} stroke={4} />
        </div>
        <div style={{ width: "90%", display: "flex", justifyContent: "center" }}>
          <IdCardIllustrationFluid accent={accent} />
        </div>
      </div>
    </div>
  );
}

// IdCardIllustration takes a pixel width; the stage is fluid, so measure
// the slot once it has laid out and pass its width through.
function IdCardIllustrationFluid({ accent }) {
  const ref = React.useRef(null);
  const [width, setWidth] = React.useState(0);
  React.useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const update = () => setWidth(Math.round(el.getBoundingClientRect().width));
    update();
    if (typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} style={{ width: "100%" }}>
      {width > 0 && <IdCardIllustration accent={accent} width={width} />}
    </div>
  );
}
